import {
    createContext,
    useContext,
    useState,
    useCallback,
    ReactNode,
    FC,
} from 'react'
import { createElement } from 'react'

interface MobileMenuContextValue {
    isOpen: boolean
    open: () => void
    close: () => void
    toggle: () => void
}

const MobileMenuContext = createContext<MobileMenuContextValue | undefined>(
    undefined
)

interface MobileMenuProviderProps {
    children: ReactNode
}

export const MobileMenuProvider: FC<MobileMenuProviderProps> = ({
    children,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const open = useCallback(() => setIsOpen(true), [])
    const close = useCallback(() => setIsOpen(false), [])
    const toggle = useCallback(() => setIsOpen((prev) => !prev), [])

    return createElement(
        MobileMenuContext.Provider,
        { value: { isOpen, open, close, toggle } },
        children
    )
}

export const useMobileMenu = (): MobileMenuContextValue => {
    const context = useContext(MobileMenuContext)
    if (context === undefined) {
        throw new Error(
            'useMobileMenu must be used within a MobileMenuProvider'
        )
    }
    return context
}
